import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import * as Objects from '@core/objects';

import { FilesListItemMenuClick } from '@core/components/files/lists/files-list-item-menu-click';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { UrlService } from '@core/services/url/url.service';
import { NotesService } from '@core/services/notes/notes.service';

@Component({
    selector: 'core-message-video',
    templateUrl: './message-video.component.html',
    styleUrls: ['./message-video.component.scss']
})
export class MessageVideoComponent implements OnInit, OnChanges{

    @Input() message: Objects.Message;
    // @Input() canCreateNotes: boolean = true;
    // @Input() notesActionText: string;
    // @Input() notesActionStyle: string;
    // @Input() prefixUrl: string = '';
    @Input() context: string = 'default';

    public selectedFile: Objects.File = null;
    public show: boolean = false;
    public videoSrc: string = '';

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download File",
            key: "download",
            icon: "download"
        },
        // {
        //     title: "Play",
        //     key: "notes",
        //     icon: "notes"
        // },
        // {
        //     title: "Remove",
        //     key: "remove",
        //     icon: "remove"
        // },
    ];
    constructor(private urlSrv: UrlService,
        // private notesSrv: NotesService 
        ){}

    ngOnInit(){
        // console.log(" MESSAGE FILEEEEEEEES ", this.message.files)

    }

    ngOnChanges(changes: SimpleChanges): void {
        // if(changes.prefixUrl){
        //     this.loadNotes();
        // }
    }

    // notesSaved(notes: Array<Objects.Note>){
    //     this.loadNotes();
    // }

    openVideo(file: Objects.File) {
        console.log("openVideo ",file)
        if(this.selectedFile != null && this.selectedFile.id == file.id){
            this.videoSrc = '';
            this.selectedFile = null;
        } else{
            this.videoSrc = this.urlSrv.build("/files/"+file.id);
            this.selectedFile = file;
        }
    }

    toggleAttachments(){
        this.show = !this.show;
    }

    onMenuClick(menu: FilesListItemMenuClick) {
        switch(menu.key) {
            // case "remove":
            //     this.onClickDeactivate(menu.file);
            //     break;
            // case "notes":
            //     this.openNotes(menu.file);
            //     break;
            case "download":
                window.location.href = this.urlSrv.build('/files/'+menu.file.id);
                break;
        }
    }

    // onClickPreview(file: Objects.File){
        // console.debug(" NEW click file preview ",file);
        // if (file != null && this.project != null){
        //     this.router.navigate(['/projects/'+this.project.id + "/files/"+file.id]);
        // }
    // }

    // protected loadNotes() {
    //     if(this.message != null && this.message.files.length > 0){
    //         if(this.canCreateNotes) {   
    //             this.menu[1].title = this.notesActionText;
    //         }
    //         this.notesSrv.findByMultipleFiles(this.message.files, this.prefixUrl+'/messages/'+this.message.id,this.context).subscribe(
    //             (notes: Array<Objects.Note>) => {
    //             console.debug(" notes loaded in new way ", notes);
    //             this.notes = notes;
    //             // this.initBubbleTexts();
    //             // this.loaded = true;
    //             },
    //             (error: any) => {
    //                 this.notes = [];
    //             });
    //     } else {
    //         this.notes = [];
    //     }
    // }

}
